/*
 * Copyright (c) 2021.
 * kurokeita
 */

/**
 * @param {*} state
 * @param {*} action
 */
import {COMPANY_LIST_SEARCH_SUCCESS, COMPANY_LIST_SUCCESS} from "../../types";

const CompanyListReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case COMPANY_LIST_SUCCESS:
            let key = action.type + '_SEARCH_RESULT';
            state[key] = action.payload.data;

            return {...state, action};
        case COMPANY_LIST_SEARCH_SUCCESS:
            let sKey = action.type + '_LIST_SEARCH_RESULT';
            state[sKey] = action.payload.data;

            return {...state, action};
        default:
            return state;
    }
};

export {CompanyListReducer}